import { useRollbar } from '@rollbar/react';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Button } from '../../components/Button';
import { Spacer } from '../../components/Spacer';
import { Typography } from '../../components/Typography';
import { PageLayout } from '../../layouts/PageLayout';
import { WidgetLayout } from '../../layouts/WidgetLayout';
import { devLog } from '../../utils/devLog';

const ErrorDisplay = ({ error, isEventError, reset }) => {
  const rollbar = useRollbar();

  useEffect(() => {
    rollbar.error(error);
  }, [error]);

  devLog('error', 'Oh No!', error);

  return (
    <PageLayout>
      <WidgetLayout>
        <Spacer direction='vertical' gap='m' centered>
          {/* icon */}
          <Typography centered variant='h2'>
            Whoops, something went wrong.
          </Typography>
          <Typography centered>
            {isEventError
              ? 'We cannot find an event with the provided URL. Please contact the venue, or click the button below to see our availability.'
              : 'Please either refresh the page or contact the restaurant if there is an issue.'}
          </Typography>
          {isEventError && <Button onClick={reset}>Make a booking</Button>}
        </Spacer>
      </WidgetLayout>
    </PageLayout>
  );
};

ErrorDisplay.defaultProps = {
  isEventError: false,
  reset: () => {},
};

ErrorDisplay.propTypes = {
  error: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]).isRequired,
  isEventError: PropTypes.bool,
  reset: PropTypes.func,
};

export default ErrorDisplay;
